import Style from './BlackFridayBanner.styles';
import { Paragraph, Headline, Image } from 'View/Common';
import { maskLeft, maskRight, mobileImg } from 'img/BlackFriday';
import { useNavigate } from '@reach/router';

export const BlackFridayBanner = () => {
  const navigate = useNavigate();
  const BLACK_FRIDAY_COUPON_CODE = 'BW2025';

  const handleClick = () => {
    navigate(`/pricing?code=${BLACK_FRIDAY_COUPON_CODE}`);
  };

  return (
    <Style
      className="black-friday-banner"
      onClick={handleClick}
      role="button"
      aria-label="Gehe zur Black Week Aktion"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClick();
        }
      }}
    >
      <div className="content-wrapper">
        <div className="wrapper left">
          <Image src={maskLeft} className="mask-left" alt="Schlafmasken Illustration für Black Friday" />
        </div>

        <div className="text-wrapper">
          <Headline level={2}>Black Week im Bett</Headline>
          <Paragraph className="copy-bold">Jetzt 60% Black-Week-Rabatt sichern</Paragraph>
        </div>

        <div className="wrapper right">
          <Image src={maskRight} className="mask-right" alt="Schlafmasken Illustration für Black Friday" />
        </div>
      </div>
      <Image src={mobileImg} className="bf_mobile_images" alt="Schlafmasken Illustration für Black Friday" />
    </Style>
  );
};
